<script setup>
const groups = [
    {
        label: 'TRIGGERS',
        items: [
            { type: 'trigger', label: 'Contact Created', subtype: 'contact_created' },
            { type: 'trigger', label: 'Field Changed', subtype: 'field_changed' },
            { type: 'trigger', label: 'Tag Assigned', subtype: 'tag_assigned' },
            { type: 'trigger', label: 'Form Submitted', subtype: 'form_submitted' },
            { type: 'trigger', label: 'Date Reached', subtype: 'date_field_reached' },
        ],
    },
    {
        label: 'ACTIONS',
        items: [
            { type: 'action_email', label: 'Send Email' },
            { type: 'action_push', label: 'Push Notification' },
            { type: 'action_add_tag', label: 'Add Tag' },
        ],
    },
    {
        label: 'FLOW CONTROL',
        items: [
            { type: 'condition', label: 'Condition (If/Else)' },
            { type: 'split', label: 'A/B Split' },
            { type: 'delay', label: 'Delay' },
            { type: 'wait_until', label: 'Wait Until' },
            { type: 'wait_for_date', label: 'Wait for Date' },
        ],
    },
    {
        label: 'GOALS',
        items: [
            { type: 'goal_check', label: 'Goal Exit' },
        ],
    },
    {
        label: 'EXIT',
        items: [
            { type: 'exit_allow_reentry', label: 'Exit and Allow Re-entry' },
        ],
    },
]

function onDragStart(event, item) {
    event.dataTransfer.effectAllowed = 'move'
    event.dataTransfer.setData('application/workflow-node', JSON.stringify(item))
}
</script>

<template>
    <aside class="workflow-palette">
        <div class="workflow-palette__header">Blocks</div>
        <div v-for="group in groups" :key="group.label" class="workflow-palette__group">
            <div class="workflow-palette__group-label">{{ group.label }}</div>
            <div
                v-for="item in group.items"
                :key="item.type + item.label"
                class="workflow-palette__item"
                draggable="true"
                @dragstart="onDragStart($event, item)"
            >
                {{ item.label }}
            </div>
        </div>
    </aside>
</template>

<style scoped>
.workflow-palette {
    width: 240px;
    background: #f9fafb;
    border-right: 1px solid #e5e7eb;
    padding: 12px 8px;
    overflow-y: auto;
    flex-shrink: 0;
}
.workflow-palette__header {
    font-size: 11px;
    font-weight: 700;
    color: #6b7280;
    letter-spacing: 0.08em;
    padding: 0 8px 8px;
    text-transform: uppercase;
}
.workflow-palette__group {
    margin-bottom: 16px;
}
.workflow-palette__group-label {
    font-size: 10px;
    font-weight: 700;
    color: #9ca3af;
    letter-spacing: 0.08em;
    padding: 4px 8px;
    text-transform: uppercase;
}
.workflow-palette__item {
    padding: 6px 12px;
    margin: 2px 0;
    border-radius: 6px;
    background: white;
    border: 1px solid #e5e7eb;
    font-size: 13px;
    cursor: grab;
    user-select: none;
    transition: background 0.15s, border-color 0.15s;
}
.workflow-palette__item:hover {
    background: #eff6ff;
    border-color: #93c5fd;
}
.workflow-palette__item:active {
    cursor: grabbing;
}
</style>
